import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchPackage(params) {
  return await request({
    url: ENDPOINT.PACKAGE,
    method: "get",
    params,
  });
}

export async function fetchPackageById(id) {
  return await request({
    url: `${ENDPOINT.PACKAGE}/${id}`,
    method: "get",
  });
}

export async function createPackage(data) {
  return await request({
    url: ENDPOINT.PACKAGE,
    method: "post",
    data,
  });
}

export async function updatePackage(id, data) {
  return await request({
    url: `${ENDPOINT.PACKAGE}/${id}`,
    method: "post",
    data,
  });
}

export async function deletePackage(id) {
  return await request({
    url: `${ENDPOINT.PACKAGE}/${id}`,
    method: "delete",
  });
}